import { styled } from '@mui/system';
import { Box, Menu, MenuItem } from '@mui/material';

export const MenuItemContainer = styled(MenuItem)({
  borderBottom: '1px solid #eaedf2 !important',
  textTransform: 'capitalize',
  color: '#66799e',
  fontSize: '0.875rem',
  padding: '1rem 1rem',
  fontWeight: '600 !important',
  minWidth: '190px',
  '&.Mui-selected': {
    backgroundColor: 'transparent'
  },
  width: '310px'
});

export const MenuContainer = styled(Menu)({
  '.MuiPopover-paper': {
    borderRadius: '10px',
    marginLeft: '16px',
    marginTop: '10px'
  },
  '.MuiMenu-list': {
    padding: '0'
  }
});

export const SubBoxContainer = styled(Box)({
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer'
});
